/* ------------------------------------------------------------------ */
/* Constants                                                          */
/* ------------------------------------------------------------------ */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const POLICY_REGEX = {
  length: /.{8,}/,
  upper: /[A-Z]/,
  lower: /[a-z]/,
  number: /\d/,
  special: /[^A-Za-z\d]/,
};
/** One month, in milliseconds. */
export const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1_000;

export const LANGS = [
  { code: "en-GB", label: "English (UK)", flag: "🇬🇧" },
  { code: "en-US", label: "English (US)", flag: "🇺🇸" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

// src/utils/constants.ts

export const QuestionnaireSlug = "cat" | "sgrq";

export const QUESTIONNAIRES = [
  { slug: "cat", labelKey: "questionnaires.cat" },
  { slug: "sgrq", labelKey: "questionnaires.sgrq" },
  { slug: "r-scale", labelKey: "questionnaires.r-scale" },
  { slug: "act", labelKey: "questionnaires.act" },
];

export const RECERT_MONTHS = 0;
export const RECERT_MS = RECERT_MONTHS * 30 * 24 * 60 * 60 * 1000; // pragmatic 90 days
export const TTL_MS = 10 * 60 * 1000;

export const MEASUREMENT_VARIANTS = [
  "RecordingSpirometry",
  "RecordingPulseScan",
  "RecordingTidalBreathing",
  "RecordingPostExertion",
  "RecordingManualAudio",
];
